function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m310.9 304.05h22.18v31.97h-22.18z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m7320.85 6875.81a7.75 7.75 0 0 0 -5.22-3.4v-.08h-.21-.22v.08a7.75 7.75 0 0 0 -5.22 3.4c-1.74 3-28.71 90-28.71 90v480.21h68.29v-480.17s-26.97-86.99-28.71-90.04z",
  fill: "#fff",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m7347.56 6959.42c-6.26-20.15-25.26-81.07-26.71-83.61a7.32 7.32 0 0 0 -4.69-3.26v86.87z",
  fill: "#cbd2d7",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m360.69 300.59h33.4v50.94h-33.4z",
  fill: "#cbd2d7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m360.69 366.91h33.4v64.2h-33.4z",
  fill: "#cbd2d7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m360.69 446.49h33.4v142.68h-33.4z",
  fill: "#cbd2d7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m360.69 604.55h33.4v167.31h-33.4z",
  fill: "#cbd2d7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m7333.8 6915.44v44h13.76c-2.88-9.28-8.44-27.14-13.76-44z",
  fill: "#8e99a3",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m378.33 300.59h15.76v50.94h-15.76z",
  fill: "#8e99a3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m378.33 366.91h15.76v64.2h-15.76z",
  fill: "#8e99a3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m378.33 446.49h15.76v142.68h-15.76z",
  fill: "#8e99a3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m378.33 604.55h15.76v167.31h-15.76z",
  fill: "#8e99a3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m325.8 291.65h68.29v2.61h-68.29z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m325.8 357.88h68.29v2.61h-68.29z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m325.53 437.15h68.29v2.61h-68.29z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m325.53 595.7h68.29v2.61h-68.29z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m7086.97 6978.25h22.18v31.97h-22.18z",
  transform: "matrix(-1 0 0 -1 7240.66 7314.27)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m7054.68 6875.81a7.74 7.74 0 0 1 5.21-3.4v-.08h.22.22v.08a7.75 7.75 0 0 1 5.22 3.4c1.74 3 28.71 90 28.71 90v480.21h-68.26v-480.17s26.94-86.99 28.68-90.04z",
  fill: "#fff",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m7092.74 6959.42c-6.37-20.47-25.17-80.75-26.61-83.28a7.35 7.35 0 0 0 -4.69-3.26v86.54z",
  fill: "#cbd2d7",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m105.97 300.59h33.4v50.94h-33.4z",
  fill: "#cbd2d7"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m105.97 604.55h33.4v167.64h-33.4z",
  fill: "#cbd2d7"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m105.97 446.49h33.4v142.68h-33.4z",
  fill: "#cbd2d7"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m105.97 366.91h33.4v64.2h-33.4z",
  fill: "#cbd2d7"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m70.49 291.65h68.29v2.61h-68.29z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m70.49 357.88h68.29v2.61h-68.29z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m70.75 437.15h68.29v2.61h-68.29z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m70.75 595.7h68.29v2.61h-68.29z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m149.16 383.43h166.13v2.61h-166.13z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m7189.05 6675.17v-1l-.45.48c-.28-.31-.45-.48-.45-.48v1c-9.58 10.42-93.07 105.63-82.61 249.58v672h166.13v-672c10.45-143.95-73.03-239.16-82.62-249.58z",
  fill: "#477d99",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m7232.67 6739.55v857.21h39v-672c5.66-77.96-16.22-141.57-39-185.21z",
  fill: "#20506d",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m7187.52 6914.56v-238.69c-11.66 12.87-88.35 103-82.53 238.69z",
  fill: "#77c4ff",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m150.07 261.45h81.98v661.1h-81.98z",
  fill: "#77c4ff"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m177.71 993.7h111.48v58.72h-111.48z",
  fill: "#fe8730"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m177.71 993.7 5.25 50.81 3.87-13.54 4.22 7.46 10.15-15.36 12.71 24.76 4.43-16.03 3.86 9.67 3.32-13.54 5.25 12.43 4.98-11.32 8.28 17.68 15.75-32.6 11.61 33.71 3.04-16.3 3.87 13.54 5.8-27.36 3.87 27.63 1.22-51.64z",
  fill: "#fedb00"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m177.71 993.7 4.15 19.31 2.76-13.82 6.43 11.06 4.07-9.68 3.87 15.2 5.25-16.03 6.36 27.09 2.48-26.81 4.42 7.18 3.6-8.28 2.76 18.51 4.06-20.17 5.66 24.5 8.09-23.38 6.51 17.39 2.1-16.85 4.25 4.97 5.8-7.73 6.48 18.51 3.75-18.51 6.08 33.98 3.31-32.05 2.21 4.42 1.38-4.42 2.77 5.53 2.88-9.92z",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "m7271.4 7313.13v-262l-72.84-72.84-.59.6a6.86 6.86 0 0 1 .94 4.28c-3.76 46.26-1.14 93.5-1.46 139.89q-.26 36.67-.2 73.33c0 14.12.9 28.67.38 43z",
  fill: "#20506d",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m7422.38 7543.94s-2.18-12.18-7-30.89a59.55 59.55 0 0 0 -18.7-29.58s-75.26-78.73-92.22-93.08-25.67-46.54-25.67-46.54l-36.1-204h-107.57l-36.11 204s-8.69 32.19-25.66 46.54-92.21 93.08-92.21 93.08a59.53 59.53 0 0 0 -18.71 29.58c-4.78 18.71-7 30.89-7 30.89v11.74h4.78l-4.78 11.74v10.88l233.31 29.54h.13.13l233.33-29.54v-10.88l-4.79-11.74h4.79z",
  fill: "#45494d",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m154.85 914.1v51.33h18.71l4.15 28.27h50.21v-81.78z",
  fill: "#6c757d"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "m4.57 868.76h229.01v64.91l-233.58-29.57v-10.88l4.78-11.74h-4.78v-11.74z",
  fill: "#afb8c0"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m7133.23 7207.27-24.39 150.93s-10.69 27.84-18.09 35.23-115.7 115.27-115.7 115.27l-10.88 34.3h191.39l-7.28-364z",
  fill: "#cbd2d7",
  transform: "translate(-6955.48 -6674.2)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m312.05 914.1v51.33h-18.7l-4.16 28.27h-50.22v-81.78z",
  fill: "#535a61"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "m462.33 868.76h-229.01v64.91l233.58-29.57v-10.88l-4.78-11.74h4.78v-11.74z",
  fill: "#535a61"
});

var _ref44 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6955.48 -6674.2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7244.62 7207.27 24.38 150.93s10.7 27.84 18.1 35.23 115.7 115.27 115.7 115.27l10.88 34.26h-191.39l7.29-364z",
  fill: "#6c757d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7301.19 7407.49-14.09-14.06c-7.4-7.39-18.09-35.23-18.09-35.23l-24.39-150.93-15-28.28-7.29 364h78.9z",
  fill: "#535a61"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7244.47 7506.53s.44-325.36 0-362.34-11.31-78.29-11.31-78.29c-20-93.26-42.35-93.27-44.24-93.1-1.88-.17-24.25-.16-44.23 93.1 0 0-10.88 41.32-11.31 78.29s0 362.34 0 362.34c-22.18 0-23.06 47-23.06 47v54.37h157.21v-54.37s-.88-47-23.06-47z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7224.15 7030.16c-15.79-52.85-30.95-57.13-34.55-57.36v57.36z",
  fill: "#cbd2d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7244.47 7506.53v-.09h-54.87v101.44h77.93v-54.37s-.88-46.98-23.06-46.98z",
  fill: "#cbd2d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7244.49 7491.07c.08-65 .36-314.75 0-346.88-.43-37-11.31-78.29-11.31-78.29-1.58-7.37-3.17-14.11-4.77-20.36h-38.81v445.53z",
  fill: "#cbd2d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7244.47 7506.53v-.09h-15.38a28.1 28.1 0 0 1 6.16 6.73l.08.07.49.49.05.06a30.15 30.15 0 0 1 6.75 10.31 31.35 31.35 0 0 1 3.31 14.45v69.33h21.6v-54.37s-.88-46.98-23.06-46.98z",
  fill: "#afb8c0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7244.47 7144.19c-.43-37-11.31-78.29-11.31-78.29-1.58-7.37-3.17-14.11-4.77-20.36h-10.65v445.53h26.75c.08-65 .36-314.75-.02-346.88z",
  fill: "#afb8c0"
}));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "m233.58 826.02h-.26-16.7l9.78 195.74h6.92.26 6.92l9.78-195.74z",
  fill: "#afb8c0"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "m268.55 407.46-34.97-15.54v-.12l-.13.06-.13-.06v.12l-34.97 15.54-5.55 22.51h9.79l4.57-14.68 26.29-2.92 26.29 2.92 4.57 14.68h9.79z",
  fill: "#535a61"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "m270.37 361.79h-24.33v-15.33h-12.46-.26-12.46v15.33h-24.33l-1.08 3.91h37.87.26 37.87z",
  fill: "#535a61"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "m150.06 250.76h166.13v2.61h-166.13z"
});

function SvgCosmicDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 466.9 1052.43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmicDrive);
export default __webpack_public_path__ + "static/media/cosmic-drive.44d5bc3c.svg";
export { ForwardRef as ReactComponent };